// extracted by mini-css-extract-plugin
module.exports = {"container":"SearchPage_container__QSG9f"};